module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dfdisOpen ? true : false) ? _c('div', {
    staticClass: "reloader"
  }, [_c('div', {
    class: ['dots', {
      'dots--active': _vm.active
    }],
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "dot"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9127682"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Dfd.vue
// module id = 454
// module chunks = 0